import { ShareUrl as ShareUrlInner } from '../components/share/share-url'
import { connect } from 'react-redux'
import { State } from '../reducers'
import { buildShareUrl } from '../saga/history'

const mapStateToProps = (state: State) => {
  return {
    url: buildShareUrl(state.condition, state.column, state.statusCondition),
  }
}

export const ShareUrl = connect(mapStateToProps)(ShareUrlInner)
